export default __webpack_public_path__ + "static/media/nantes13.7d6eac65.jpg";